<template>
  <v-app>
    <v-app-bar dense fixed clipped-left app color="primary" dark 
      extended :extension-height="4">
        <v-toolbar-title>{{this.$t('applications.title')}} -&nbsp;</v-toolbar-title>
        <v-menu :nudge-width="100">
          <template v-slot:activator="{ on }">
          <v-toolbar-title v-on="on">
            <span v-if="$store.getters['competition']">{{ $store.getters['competition'].title }}</span>
            <v-icon>arrow_drop_down</v-icon>
          </v-toolbar-title>
          </template>

          <v-list>
            <v-list-item
              v-for="item in this.$store.getters['competitions']"
              :key="item.id"
              @click="selectCompetition(item)">
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-spacer></v-spacer>

        <v-menu :nudge-width="100">
          <template v-slot:activator="{ on }">
            <v-toolbar-title v-on="on">
              <span><flag :iso="localeCountry" /></span>
              <v-icon>arrow_drop_down</v-icon>
            </v-toolbar-title>
          </template>

          <v-list>
            <v-list-item
              v-for="item in Object.keys(this.$i18n.messages)"
              :key="item"
              @click="changeLocale(item)">
              <v-list-item-title><flag :iso="item | localeToCountry" /> {{ $t('langNative.'+item) }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        
        <v-progress-linear v-if="$store.getters['loading']" slot="extension" :indeterminate="true" class="ma-0" color="accent" :height="4"></v-progress-linear>  
    </v-app-bar>
    <v-content>
      <v-card>
        <v-card-text>
          <h2 class="my-2">{{ this.$t("application.individual") }}</h2>
          <v-data-table :headers="individualHeaders" :items="individuals" class="elevation-1" dense 
            disable-pagination hide-default-footer>
            <template v-slot:item.competitor="{ item }">
              <flag :iso="item.applicationCompetitors[0].competitor.country" />
              &nbsp; {{item.applicationCompetitors[0].competitor.firstName}} 
              {{item.applicationCompetitors[0].competitor.lastName}}
              <v-icon color="success" v-if="item.status != 'Filed'">check</v-icon>
            </template>
          </v-data-table>
          <h2 class="my-2">{{ this.$t("application.tandem") }}</h2>
          <v-data-table :headers="teamHeaders" :items="tandems" class="elevation-1" dense 
            disable-pagination hide-default-footer>
            <template v-slot:item.title="{ item }">
              {{item.title}} 
              <v-icon color="success" v-if="item.status != 'Filed'">check</v-icon>
            </template>
            <template v-slot:item.competitors="{ item }">
              <v-chip v-for="c in item.applicationCompetitors" :key="c.id">
                <flag :iso="c.competitor.country" />
                &nbsp; {{c.competitor.firstName}} {{c.competitor.lastName}}
              </v-chip>
            </template>
          </v-data-table>
          <h2 class="my-2">{{ this.$t("application.relay") }}</h2>
          <v-data-table :headers="teamHeaders" :items="relays" class="elevation-1" dense 
            disable-pagination hide-default-footer>
            <template v-slot:item.title="{ item }">
              {{item.title}} 
              <v-icon color="success" v-if="item.status != 'Filed'">check</v-icon>
            </template>
            <template v-slot:item.competitors="{ item }">
              <v-chip v-for="c in item.applicationCompetitors" :key="c.id">
                <flag :iso="c.competitor.country" />
                &nbsp; {{c.competitor.firstName}} {{c.competitor.lastName}}
              </v-chip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-content>
  </v-app>
</template>

<script>
import {
    VCard,
    VCardActions,
    VCardTitle,
    VCardText,
    VMenu,
    VSelect,
    VProgressLinear,
    VIcon
} from 'vuetify/lib'
import fccapi from "./fccapi.js";

export default {
  name: 'ApplicationsPage',
  data () {
    return {
      competitions: null,
      loading: false,
      applications: []
    }
  },
  computed: {
    localeCountry: function() {
      return this.$i18n.locale.split('-')[1]
    },
    selectedCompetition: {
      set(id) {
        this.$store.dispatch('selectCompetition', id);
      },
      get(){
        return this.$store.getters['competitionId'];
      }
    },
    competitionsList: function(){
      return this.$store.getters['competitions'] || [];
    },
    competitionsLoaded: function() {
      return this.competitions != null;
    },
    individuals: function() {
      return this.applications.filter((a) => a.applicationType == 0);
    },
    tandems: function() {
      return this.applications.filter((a) => a.applicationType == 1);
    },
    relays: function() {
      return this.applications.filter((a) => a.applicationType == 2);
    },
    individualHeaders: function() {
      return [
        {
          text: this.$t("competitors.firstName"),
          value: 'competitor',
          sortable: false
        },
        {
          text: this.$t("competitor.department"),
          value: 'applicationCompetitors[0].competitor.department'
        }
      ];
    },
    teamHeaders: function() {
      return [
        {
          text: this.$t("application.title"),
          value: 'title',
        },
        {
          text: this.$t("competitors.title"),
          value: 'competitors',
          sortable: false
        }
      ];
    }
  },
  methods: {
    applicationType: function(i) {
        return this.$t('application.'+Array('individual', 'tandem', 'relay')[i]);
    },
    changeLocale(locale){
      this.$i18n.locale = locale
    },
    closeErrorDialog(){
      this.$store.dispatch('reportError', null)
    },
    selectCompetition: function(c){
      this.$store.dispatch('selectCompetition', c.id);
      this.reload();
    },
    reload: function() {
      fccapi.competitionGet("applications/public").then(d => {
        this.applications = d.data;
      });
    }
  },
  mounted: function(){
    this.$store.dispatch('loadCompetitions').then(rr => {
      this.selectCompetition(rr[rr.length - 1]);
    })
  },
  components: {
    VSelect,
    VMenu,
    VCard,
    VCardActions,
    VCardText,
    VIcon,
    "v-progress-linear": VProgressLinear
  }
}
</script>
